<template>
  <a-modal
    :wrapClassName="disabled ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="基地" prop="cooperativeBaseId">
          <a-select v-model="form.cooperativeBaseId" :disabled="disabled">
            <a-select-option
              v-for="item in list"
              :key="item"
              :value="item.id"
              >{{ item.baseName }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="活动年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
            :disabled="disabled"
          />
        </a-form-model-item>
        <a-form-model-item label="主题" prop="subject">
          <a-input
            v-model="form.subject"
            placeholder="请输入主题"
            :disabled="disabled"
          />
        </a-form-model-item>
        <a-form-model-item label="参与人数" prop="peopleNum">
          <a-input-number
            v-model="form.peopleNum"
            min="1"
            precision="0"
            @blur="blurValue"
            :disabled="disabled"
          />
        </a-form-model-item>
        <a-form-model-item label="地点" prop="address">
          <a-input
            v-model="form.address"
            placeholder="请输入地点"
            :disabled="disabled"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        cooperativeBaseId: "",
        acquireYear: "",
        peopleNum: "",
        subject: "",
        address: "",
      },
      disabled: false,
      rules: {
        cooperativeBaseId: [
          {
            required: true,
            message: "请选择基地",
            trigger: "change",
          },
        ],
        acquireYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        subject: [
          {
            required: true,
            message: "请输入主题",
            trigger: "blur",
          },
        ],
        peopleNum: [
          {
            required: true,
            message: "请输入参与人数",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地点",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      list: [],
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
    // this.getList();
  },
  methods: {
    getList(id) {
      getAction("/lxbase/lxApplyCooperativeBase/getList", { applyId: id }).then(
        (res) => {
          this.list = res.result;
        }
      );
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleChange() {
      // console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    handleClearAcquireYear(val) {
      this.form.acquireYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      // this.form.acquireYear = value;
      const year = moment(value).format("YYYY");
      this.form.acquireYear = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("acquireYear");
      // this.yearShowOne = false;
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.disabled = false;
      // this.getxwlist();
      // this.getcgjb();
      // this.getkclist();
      if (type == "add") {
        this.getList(record.id);
        this.form = {};
        this.form.applyId = record.id;
        this.title = "新增活动";
        this.form.acquireYear = new Date().getFullYear() + "";
      } else if (type === "audit-edit") {
        this.getList(record.applyId);
        this.title = "编辑活动";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          title: record.title,
          achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          subject: record.subject,
          address: record.address,
          cooperativeBaseId: record.cooperativeBaseId,
          peopleNum: record.peopleNum,
        };
      } else if (type == "see") {
        this.disabled = true;
        this.getList(record.applyId);
        this.title = "查看活动";
        this.saveText = "关闭";
        this.form = {
          title: record.title,
          achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          subject: record.subject,
          address: record.address,
          cooperativeBaseId: record.cooperativeBaseId,
          peopleNum: record.peopleNum,
        };
      } else {
        console.log(record);
        this.getList(record.applyId);
        this.title = "编辑活动";
        this.form = {
          title: record.title,
          // achievementType: record.achievementType,
          // amount: record.amount,
          // levelType: record.levelType,
          // courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          // content: record.content,
          subject: record.subject,
          address: record.address,
          peopleNum: record.peopleNum,
          cooperativeBaseId: record.cooperativeBaseId,
        };
        this.teacherdata = record;
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      this.jblist = [
        {
          value: "国家级",
          title: "国家级",
        },
        {
          value: "省级",
          title: "省级",
        },
        {
          value: "市级",
          title: "市级",
        },
        {
          value: "县级",
          title: "县级",
        },
        {
          value: "校级",
          title: "校级",
        },
        {
          value: "其他",
          title: "其他",
        },
      ];
      // getAction("/baseCommon/getDictItemsByCode?code=achievement_level",).then((res) => {
      // 	if (res.code == 200) {
      // 		this.jblist=res.result;
      // 	}
      // });
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      if (this.disabled) {
        this.visible = false;
        return false;
      }
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != "" &&
        this.type == "add"
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            postAction("/lx/lxPracticeBase/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            if (
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              if (typeof this.form.acquireYear == "object") {
                params1.acquireYear =
                  new Date(this.form.acquireYear).getFullYear() + "";
              }
              params1.applyType = this.applyType;
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              if (typeof this.form.acquireYear == "object") {
                params.acquireYear =
                  new Date(this.form.acquireYear).getFullYear() + "";
              }
              params.applyType = this.applyType;
              putAction("lx/lxPracticeBase/edit", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>